import { render, staticRenderFns } from "./SearchResultModal.vue?vue&type=template&id=6b83908e&"
import script from "./SearchResultModal.vue?vue&type=script&lang=ts&"
export * from "./SearchResultModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports